module.exports = __webpack_public_path__ + "img/sonargroup-products.f47e129f.webp";